<template>
  <div class="container justify-content-center mt-5" v-bind:class="{'pt-5 pb-5': resultPage.isMobile === true}">



    <div class="feedback-full">
      <feedback-full></feedback-full>
    </div>
    <div class="">
      <router-link
          v-slot="{ href, route, navigate, isActive, isExactActive }"
          :to="{ name: 'Welcome', params: { uuid: id } }"
      >
        <div @click="navigate" class="btn btn-block w-100 btn-info mt-3">
          <i class="fa lh-inherit fa-arrow-left"></i> {{ 'Back' | trans }}
        </div>
      </router-link>
    </div>

  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import FeedbackFull from "../Elements/FeedbackFull.vue";

export default {
  name: "FeedbackContent",
  props: {},
  components: {FeedbackFull},
  mixins: [
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>

.feedback-full {
  width: 100%;
  background: white;
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  padding: 20px;
}
</style>
